export default __webpack_public_path__ + "static/media/video-icon.a9e25554.jpg";